
export const formControlContainer = {
    // minWidth:"20em"
    // backgroundColor:"rgb(99 97 100)"
    backgroundColor: "white",
    color:"black"
}

export const inputFieldContainer = {
  margin:"0.8em"
}

export const inputFieldStyle = {
   width:"100%"
}

export const uploadButton = {
    backgroundColor:"#B22727"
}
export const cancelButton = {
    color:"black"
}